import { defineMessages } from 'react-intl';

export const dateSocialShareMessages = defineMessages({
  hideDate: {
    id: 'dateSocialShare.hideDate',
    defaultMessage: 'Hide date',
  },
  hideShare: {
    id: 'dateSocialShare.hideShare',
    defaultMessage: 'Hide share buttons',
  },
});

const DateSocialShareSchema = (intl: any) => ({
  title: 'Date / Social share',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['hideDate', 'hideShare'],
    },
  ],
  properties: {
    hideDate: {
      title: intl.formatMessage(dateSocialShareMessages.hideDate),
      type: 'boolean',
      default: false,
    },
    hideShare: {
      title: intl.formatMessage(dateSocialShareMessages.hideShare),
      type: 'boolean',
      default: false,
    },
  },
  required: [],
});

export default DateSocialShareSchema;
